import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";

const HousekeepingResponse = z.object({
    date_housekeeping: z.string(),
    property_id: z.string(),
    total_rooms: z.coerce.number(),
    room_reserved: z.coerce.number(),
    arrival_room: z.coerce.number(),
    departure_room: z.coerce.number(),
    in_house_room: z.coerce.number(),
    total_adults: z.coerce.number(),
    total_childs: z.coerce.number(),
    cancel_room: z.coerce.number(),
    total_room_maintenance: z.coerce.number(),
    occupancy: z.coerce.string(),
});

export const HousekeepingResponseSchema = BaseResponseSchema(z.array(HousekeepingResponse));
export type HousekeepingResponseSchemaType = z.infer<typeof HousekeepingResponseSchema>;
export type HousekeepingResponseType = z.infer<typeof HousekeepingResponse>;
export { HousekeepingResponse };
export const SingleHousekeepingResponseSchema = BaseResponseSchema(HousekeepingResponse);